@if (resolvedTitle()) {
    <p class="highlight-title sir-text-style-paragraph-m-bold" [id]="titleId">{{ resolvedTitle() }}</p>
}

<dl class="highlight-list" [attr.aria-labelledby]="resolvedTitle() ? titleId : null">
    @for (highlight of resolvedHighlights(); track $index) {
        <div class="highlight-pair">
            <dt class="highlight-label">{{ highlight.label }}</dt>
            <dd class="highlight-value">{{ highlight.value }}</dd>
        </div>
    }
</dl>
